const password = {
    unsupported_encryption_method: 'O método de criptografia {{name}} não é suportado.',
    pepper_not_found: 'Password pepper não encontrada. Por favor, verifique seus envs principais.',
    rejected: 'Senha rejeitada. Por favor, verifique se sua senha atende aos requisitos.',
};
export default Object.freeze(password);
